import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  singleValue: {
    fontSize: 16,
  },
});

const JoinConversationSingleValue = ({ data: { user }, innerProps }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.singleValue} {...innerProps}>
      {user?.avaName || null}
    </Typography>
  );
};

export default JoinConversationSingleValue;
